import React,  { Component } from 'react'

// ui
import Modal from '../../../components/feedback/modal'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// select report component
import SelectReportComponent from '../../../components/select_reports'

class ModalSelectReportLowerTier extends Component{

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    _userSelectReport = (reports) => {
        console.log("User select report")
        this.props.dismiss()
        this.props.updateSelectedReport([])
        this.props.updateSelectedReport(reports)
    }

    render(){
        const { visible, report } = this.props
        let {selected_report } = this.props 
        if (!visible) selected_report = []
    
        return (
            <Modal
                visible = {visible}
                title = "Lựa chọn tài liệu căn cứ"
                onOK={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                width={700}
                footer={
                    null
                }
            >
                <SelectReportComponent 
                    onSuccess = {(reports) => this._userSelectReport(reports)}
                    onCancel = {() => this._handleCancel()}
                    initReport = {selected_report}
                    tier_created = {report.tier_created }
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    console.log("state : ", state)
    return {
        report: state.qbreport.current_report,
        visible: state.qbreport.modalSelectReportLowerTierState,
        selected_report: state.qbreport.selected_report
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalSelectReportLowerTier())
        },
        updateSelectedReport: selected_report => {
            dispatch(ReportActions.action.updateSelectedReportLowerTier(selected_report))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectReportLowerTier)